module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro.e8b5cce0.mp3";